/* ==========================================================================
   NEW PORT VELA - V3 homepage: rosa de los vientos.
   The garments stand in a circle on a compass rose seen in perspective. One
   number, pos (fractional while moving), drives everything. The page always
   scrolls freely: the rose turns with the arrows, the keyboard, a sideways
   drag or trackpad swipe (with a flick), or a click on a side garment.
   Garment i stands on bearing 360 - i·360/n, so the next garment is always on
   the right and the rose reads clockwise like a real compass.

   Layers, back to front: the rose (drawn once, flat, laid on the floor with a
   CSS 3D transform), the 8 point labels, then for every visible garment its
   VEIL (a small canvas: one soft garment-shaped patch in the background colour,
   the same for every product), and above all the veils the GARMENTS (the 360
   photos, blended with multiply so their white background disappears). Each veil
   moves and scales with its garment and hides the rose behind it, so no garment
   is ever see-through. Nothing per product: a new 360
   works as soon as it is uploaded.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-rosa]');
  if (!root || !window.NPV || !NPV.Spin) return;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var stage = root.querySelector('[data-rosa-stage]');
  var cvs = root.querySelector('[data-rosa-floor]');
  var labels = $$('[data-rosa-point]', root);
  var items = $$('[data-rosa-item]', root), caps = $$('[data-rosa-cap]', root);
  var countEl = root.querySelector('[data-rosa-count]');
  var N = items.length;
  if (!N) return;
  var reduce = !!NPV.reduceMotion;
  var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  root.classList.toggle('is-touch', !!touch);

  var TAU = Math.PI * 2, C = 3.2; /* C: camera distance in ring radii (bigger = flatter depth) */
  /* the 360 photos have ~9 % of empty floor under the garment (hem measured at 0.87-0.96 of the
     frame height on the silhouettes): the photo's bottom edge goes LIFT below the rim point */
  var LIFT = 0.09;
  var STEP = TAU / N;
  var pos = 0, cur = -1, target = 0, W = 0, H = 0, g = {}, tween = 0, moving = false, startT = 0;

  /* one veil canvas per garment, right under it */
  var VW = 290, VH = 360; /* same proportions as the 360 photo (868 x 1080) */
  var occs = items.map(function (it) {
    var c = document.createElement('canvas');
    c.className = 'rosa__occ'; c.width = VW; c.height = VH; c.setAttribute('aria-hidden', 'true');
    it.parentNode.insertBefore(c, it);
    return c;
  });
  var st = items.map(function () { return { t: '', o: '', z: '', v: '', y0: 1e9 }; });
  var lastL = labels.map(function () { return ''; });

  /* ---------- geometry ---------- */
  function measure() {
    var r = stage.getBoundingClientRect();
    W = r.width; H = r.height;
    if (!W || !H) return false;
    var narrow = W < 760;
    /* phones: a deeper, wider rose (seen more from above) and slightly smaller garments, the side
       ones a little smaller still, so the wheel shows between them and each stands on its point */
    var RX = narrow ? Math.min(W * 0.41, H * 0.62) : Math.min(W * 0.34, H * 1.15);
    var RY = RX * (narrow ? 0.52 : 0.26);
    var kF = C / (C - 1), boostF = narrow ? 1.8 : 1.6;
    var feet = H - Math.max(12, H * 0.07); /* where the front garment's base touches the rim */
    var frontH = Math.min((feet - 6) / (1 - LIFT), H * 0.86, (narrow ? W * 0.46 : W * 0.46) / 0.8037);
    g = { RX: RX, RY: RY, cx: W / 2, cy: feet - RY * kF, fH: frontH, fW: frontH * 0.8037, h0: frontH / (kF * boostF), boost: boostF - 1, LR: narrow ? 1.1 : 1.17, narrow: narrow };
    items.forEach(function (it, i) {
      it.style.width = occs[i].style.width = g.fW + 'px';
      it.style.height = occs[i].style.height = g.fH + 'px';
      st[i].t = ''; st[i].y0 = 1e9;
    });
    g.top = stage.offsetTop; g.pinH = stage.parentNode.offsetHeight;
    drawRose();
    return true;
  }
  /* screen point of angle phi on the ring of radius r (in ring radii); phi 0 = facing us */
  function P(phi, r) {
    var c = Math.cos(phi) * r, s = Math.sin(phi) * r, k = C / (C - c);
    return { x: g.cx + s * g.RX * k, y: g.cy + c * g.RY * k, k: k };
  }
  /* size of a garment standing on the rim at angle phi */
  function slot(phi) {
    var c = Math.cos(phi), q = P(phi, 1);
    var h = g.h0 * q.k * (1 + g.boost * Math.pow(Math.max(0, c), 8));
    return { x: q.x, y: q.y, h: h, sc: h / g.fH, depth: (c + 1) / 2 };
  }
  function wrapA(a) { a = ((a + Math.PI) % TAU + TAU) % TAU - Math.PI; return a; }

  /* ---------- the rose: drawn once, flat, then laid down in CSS 3D ----------
     A CSS plane tilted by rotateX(a) under perspective(p) projects exactly like P():
     cos(a) = RY/RX and p = C·RX·sin(a), with the plane centred on (cx, cy). */
  var EXT = 1.14; /* half size of the drawing, in ring radii; the garments stand on the rim at r = 1 */
  function drawRose() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var R = g.RX, S = Math.round(2 * EXT * R);
    cvs.width = Math.round(S * dpr); cvs.height = Math.round(S * dpr);
    cvs.style.width = S + 'px'; cvs.style.height = S + 'px';
    cvs.style.left = (g.cx - S / 2) + 'px'; cvs.style.top = (g.cy - S / 2) + 'px';
    var a = Math.acos(Math.min(0.999, g.RY / g.RX));
    g.tilt = a; g.persp = C * R * Math.sin(a);
    var x = cvs.getContext('2d');
    x.setTransform(dpr, 0, 0, dpr, S / 2 * dpr, S / 2 * dpr);
    x.clearRect(-S, -S, 2 * S, 2 * S);
    x.lineCap = 'round';
    /* point on the flat rose at bearing b (radians, clockwise) and radius r; bearing 0 points at us before turning */
    var F = function (b, r) { return [Math.sin(-b) * r * R, Math.cos(-b) * r * R]; };
    var navy = function (al) { return 'rgba(0,38,62,' + al + ')'; };
    var circle = function (r, al, w) { x.strokeStyle = navy(al); x.lineWidth = w; x.beginPath(); x.arc(0, 0, r * R, 0, TAU); x.stroke(); };
    circle(1.04, 0.36, 1.4); circle(0.96, 0.22, 1.1); circle(0.18, 0.3, 1.1);
    for (var d = 0; d < 360; d += 5) {
      var b = d * Math.PI / 180, big = d % 45 === 0, mid = d % 15 === 0;
      var p1 = F(b, 0.96), p2 = F(b, big ? 1.09 : mid ? 1.03 : 1.0);
      x.strokeStyle = navy(big ? 0.5 : mid ? 0.32 : 0.2); x.lineWidth = big ? 1.6 : 1.1;
      x.beginPath(); x.moveTo(p1[0], p1[1]); x.lineTo(p2[0], p2[1]); x.stroke();
    }
    x.strokeStyle = navy(0.16); x.lineWidth = 1.1; x.beginPath();
    for (var m = 0; m < 16; m++) { var bm = (m * 22.5 + 11.25) * Math.PI / 180, q1 = F(bm, 0.18), q2 = F(bm, 0.45); x.moveTo(q1[0], q1[1]); x.lineTo(q2[0], q2[1]); }
    x.stroke();
    [1, 3, 5, 7, 0, 2, 4, 6].forEach(function (j) {
      var card = j % 2 === 0, bj = j * Math.PI / 4, w = card ? 0.12 : 0.09;
      var tip = F(bj, card ? 0.9 : 0.62), l = F(bj - Math.PI / 4, w), r = F(bj + Math.PI / 4, w);
      x.fillStyle = navy(card ? 0.8 : 0.55);
      x.beginPath(); x.moveTo(tip[0], tip[1]); x.lineTo(0, 0); x.lineTo(l[0], l[1]); x.closePath(); x.fill();
      x.fillStyle = 'rgba(191,211,228,' + (card ? 0.95 : 0.8) + ')';
      x.beginPath(); x.moveTo(tip[0], tip[1]); x.lineTo(0, 0); x.lineTo(r[0], r[1]); x.closePath(); x.fill();
      x.strokeStyle = navy(0.45); x.lineWidth = 0.9;
      x.beginPath(); x.moveTo(l[0], l[1]); x.lineTo(tip[0], tip[1]); x.lineTo(r[0], r[1]); x.stroke();
    });
  }

  /* ---------- the veil ----------
     One generic shape for every garment, measured on the silhouettes of all 20 NewPortVela 360s
     (96 angles each): at each height of the photo, the half width that the garments reach in at
     least 5 % of their turn, smoothed. So it covers a garment at every angle (front view with the
     sleeves out is the widest), with a thin soft edge. It ends at the rim point (0.91 of the photo,
     see LIFT): the ring and the ticks in front of the garment's feet stay visible over the hem, as
     they are in front of it. [y, half width], both as fractions of the photo. */
  var VEIL = [[0.035, 0.10], [0.06, 0.14], [0.09, 0.20], [0.12, 0.265], [0.15, 0.325], [0.18, 0.352],
    [0.24, 0.385], [0.30, 0.415], [0.36, 0.44], [0.42, 0.452], [0.48, 0.44], [0.54, 0.435],
    [0.88, 0.437], [0.905, 0.42]];
  var veil = document.createElement('canvas');
  veil.width = VW; veil.height = VH;
  (function () {
    var v = veil.getContext('2d'), off = VW * 3, j;
    /* feather: draw the shape off the canvas and let only its blurred shadow land on it */
    v.shadowColor = '#000'; v.shadowBlur = VW * 0.024; v.shadowOffsetX = off;
    v.beginPath();
    v.moveTo(VW / 2 - off, VEIL[0][0] * VH - VW * 0.02);
    for (j = 0; j < VEIL.length; j++) v.lineTo((0.5 + VEIL[j][1]) * VW - off, VEIL[j][0] * VH);
    for (j = VEIL.length - 1; j >= 0; j--) v.lineTo((0.5 - VEIL[j][1]) * VW - off, VEIL[j][0] * VH);
    v.closePath(); v.fill();
  })();
  function spinEl(it) { return it.querySelector('.rosa__spin:not([hidden]) [data-spin]'); }
  function spinOf(it) { var el = spinEl(it); return el ? (el.__spin || new NPV.Spin(el)) : null; }
  /* paint one garment's veil in the section's background gradient, as it falls behind that garment
     (repainted only when the garment has moved up or down enough to change that colour) */
  function drawOcc(i, bottom, h) {
    var S = st[i];
    if (Math.abs(S.y0 - bottom) < 6) return;
    S.y0 = bottom;
    var x = occs[i].getContext('2d');
    x.globalCompositeOperation = 'source-over';
    x.clearRect(0, 0, VW, VH);
    x.drawImage(veil, 0, 0);
    x.globalCompositeOperation = 'source-in';
    /* the pin's gradient (white to 36 %, then to --paper at the bottom), in this canvas' own pixels */
    var top = g.top + bottom - h, k = VH / h;
    var gr = x.createLinearGradient(0, (0 - top) * k, 0, (g.pinH - top) * k);
    gr.addColorStop(0, '#fff'); gr.addColorStop(0.36, '#fff'); gr.addColorStop(1, '#f4f7fa');
    x.fillStyle = gr; x.fillRect(0, 0, VW, VH);
    x.globalCompositeOperation = 'source-over';
  }

  /* ---------- one frame ---------- */
  function render() {
    if (!g.fH && !measure()) return;
    var P0 = pos * STEP, vis = [];
    cvs.style.transform = 'perspective(' + g.persp.toFixed(1) + 'px) rotateX(' + g.tilt.toFixed(4) + 'rad) rotateZ(' + P0.toFixed(4) + 'rad)';
    items.forEach(function (it, i) {
      var phi = i * STEP - P0, a = Math.abs(wrapA(phi)), s = slot(phi), S = st[i];
      /* the front garment and its neighbours stand clear; the next ones fade in (or out) gradually over
         the whole step, so a garment never pops up half transparent in the middle of a turn */
      var fe = Math.min(STEP * 2, 2.1), u = a <= STEP ? 1 : a >= fe ? 0 : (fe - a) / (fe - STEP);
      var op = u * u * (3 - 2 * u);
      var v = op < 0.01 ? 'hidden' : ''; /* '' so they stay hidden while the whole section is hidden (sea entrance) */
      if (v !== S.v) { it.style.visibility = occs[i].style.visibility = v; S.v = v; if (v === 'hidden' && i !== cur) rewind(it); }
      if (v === 'hidden') return;
      var bottom = s.y + LIFT * s.h;
      var t = 'translate3d(' + (s.x - g.fW / 2).toFixed(1) + 'px,' + (bottom - g.fH).toFixed(1) + 'px,0) scale(' + s.sc.toFixed(4) + ')';
      if (t !== S.t) { it.style.transform = occs[i].style.transform = t; S.t = t; }
      var o = op.toFixed(2); if (o !== S.o) { it.style.opacity = occs[i].style.opacity = o; S.o = o; }
      vis.push({ i: i, depth: s.depth, bottom: bottom, h: s.h });
    });
    /* stacking by depth order only (changes only when two garments cross). All the veils lie under
       all the garments: a veil only ever hides the rose, never a neighbouring garment (on phones the
       garments stand close together and a veil on top would cut into the one beside it) */
    vis.sort(function (p, q) { return p.depth - q.depth; });
    vis.forEach(function (o, rank) {
      var z = String(10 + rank), S = st[o.i];
      if (z !== S.z) { occs[o.i].style.zIndex = z; items[o.i].style.zIndex = String(30 + rank); S.z = z; }
      drawOcc(o.i, o.bottom, o.h);
    });
    labels.forEach(function (el, t) {
      var phi = -t * Math.PI / 4 - P0, q = P(phi, g.LR); /* point labels just outside the rim (closer in on phones, so E and W are not cut) */
      var f = (0.22 + 0.78 * (Math.cos(phi) + 1) / 2) * Math.max(0, Math.min(1, (H - 6 - q.y) / 18));
      /* phones: the pure side points sit right beside a garment, whose veil would slice the letter ('W' read as 'V'): fade them out there */
      if (g.narrow) f *= Math.min(1, Math.abs(Math.cos(phi)) * 3);
      var val = 'translate3d(' + q.x.toFixed(1) + 'px,' + q.y.toFixed(1) + 'px,0) translate(-50%,-50%) scale(' + Math.max(0.75, q.k).toFixed(3) + ')|' + f.toFixed(2);
      if (val === lastL[t]) return;
      lastL[t] = val; var parts = val.split('|');
      el.style.transform = parts[0]; el.style.opacity = parts[1];
    });
    var fr = ((Math.round(pos) % N) + N) % N;
    if (fr !== cur) setFront(fr);
    /* the labels and garments stay hidden until placed here once (before, they piled up at the top left) */
    if (!root.classList.contains('is-ready')) root.classList.add('is-ready');
  }
  /* at most one frame per animation frame, and only while the rose is on screen and something moved */
  var dirty = true, looping = false, onScreen = false;
  function tick() {
    looping = false;
    if (onScreen && dirty) { dirty = false; render(); }
  }
  function schedule() { dirty = true; if (!looping && onScreen) { looping = true; requestAnimationFrame(tick); } }

  /* leaving the front a garment simply stops where it is (video frame or hand-turned frame): no jump
     in the middle of a turn. Once out of sight it goes back to its front view. */
  function rest(it) { var el = spinEl(it), sp = el && el.__spin; if (sp) sp.stop(); }
  function rewind(it) {
    var el = spinEl(it), sp = el && el.__spin;
    if (!sp) return;
    if (sp.hand) { sp.hand = false; sp.canvas.hidden = true; }
    if (sp.video && sp.video.currentTime) { try { sp.video.currentTime = 0; } catch (e) {} }
  }
  /* the garments either side of the front warm only their video's metadata before they arrive (not the
     whole loop: 3 full streams at once cost ~2-4 MB on phones); play() on arrival loads the rest */
  function prepare(it) {
    var el = it && spinEl(it); if (!el || reduce) return;
    var sp = el.__spin || new NPV.Spin(el);
    if (it !== items[cur]) sp.stop();
    var v = sp.video;
    if (v && !v.getAttribute('src') && sp.src) { v.preload = 'metadata'; v.src = sp.src; }
  }
  function startFront() {
    clearTimeout(startT);
    if (moving || cur < 0 || document.body.classList.contains('is-intro')) return;
    startT = setTimeout(function () {
      if (moving) return;
      var s = spinOf(items[cur]); if (s) s.start();
      prepare(items[(cur + 1) % N]); prepare(items[(cur + N - 1) % N]);
    }, 120);
  }
  function setFront(f) {
    var prev = cur; cur = f;
    if (prev >= 0 && items[prev]) rest(items[prev]);
    items.forEach(function (it, i) {
      it.classList.toggle('is-front', i === f);
      var fig = it.querySelector('.rosa__fig'); if (fig) fig.inert = i !== f; /* side 360s are not focusable */
    });
    caps.forEach(function (c, i) { c.hidden = i !== f; });
    if (countEl) countEl.textContent = (f + 1) + ' / ' + N;
    startFront();
  }

  /* ---------- turning ---------- */
  function norm(p) { return ((p % N) + N) % N; }
  function settle() { moving = false; root.classList.remove('is-moving'); }
  function go(i, fast) {
    cancelAnimationFrame(tween);
    i = norm(Math.round(i)); target = i;
    var from = norm(pos), d = i - from;
    if (d > N / 2) d -= N; else if (d < -N / 2) d += N;
    if (reduce || Math.abs(d) < 0.001) { pos = i; settle(); render(); startFront(); return; }
    moving = true; root.classList.add('is-moving');
    var t0 = performance.now(), dur = (fast ? 300 : 460) + Math.min(3, Math.abs(d)) * 120;
    (function step(now) {
      var t = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - t, 3);
      pos = from + d * e; render();
      if (t < 1) { tween = requestAnimationFrame(step); return; }
      pos = i; settle(); render(); startFront();
    })(t0);
  }
  var unit = function () { return g.RX * 1.1 * STEP; }; /* px of drag per garment */

  var prevB = root.querySelector('[data-rosa-prev]'), nextB = root.querySelector('[data-rosa-next]');
  /* quick repeated taps add up: each one goes one past the garment already on its way */
  if (prevB) prevB.addEventListener('click', function () { go((moving ? target : cur) - 1); });
  if (nextB) nextB.addEventListener('click', function () { go((moving ? target : cur) + 1); });
  var justDragged = false;
  $$('[data-rosa-go]', root).forEach(function (b) {
    b.addEventListener('click', function () { if (!justDragged) go(parseInt(b.getAttribute('data-rosa-go'), 10)); });
  });
  /* arrow keys turn the rose from the stage or the arrow buttons, not from inside a caption */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (!(e.target === root || e.target === stage || e.target.closest('.rosa__ctl'))) return;
    e.preventDefault();
    go((moving ? target : cur) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  /* drag the rose sideways, with a flick. On touch screens the whole stage turns the rose;
     with a mouse the garment in front keeps its own drag to turn it 360. */
  var down = false, dragging = false, sx = 0, sy = 0, spos = 0, pid = null, vel = 0, lx = 0, lt = 0;
  stage.addEventListener('pointerdown', function (e) {
    if (e.button > 0 || e.target.closest('a')) return;
    if (!touch && e.target.closest('.rosa__item.is-front [data-spin]')) return;
    down = true; dragging = false; justDragged = false; sx = lx = e.clientX; sy = e.clientY; lt = e.timeStamp; vel = 0; pid = e.pointerId;
  });
  stage.addEventListener('pointermove', function (e) {
    if (!down || e.pointerId !== pid) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (!dragging) {
      if (Math.abs(dx) < 6) return;
      if (Math.abs(dy) > Math.abs(dx) * 1.1) { down = false; return; }
      dragging = true; justDragged = true; moving = true;
      cancelAnimationFrame(tween); clearTimeout(startT);
      if (cur >= 0) rest(items[cur]);
      spos = pos; sx = e.clientX;
      try { stage.setPointerCapture(pid); } catch (x) {}
      root.classList.add('is-dragging', 'is-moving');
      dx = 0;
    }
    var dt = Math.max(1, e.timeStamp - lt);
    vel = 0.75 * vel + 0.25 * ((e.clientX - lx) / dt); lx = e.clientX; lt = e.timeStamp;
    pos = spos - dx / unit(); schedule();
    if (e.cancelable) e.preventDefault();
  });
  var end = function () {
    if (!down) return;
    down = false;
    if (!dragging) return;
    dragging = false; root.classList.remove('is-dragging');
    /* a flick carries on: ~220 ms of the release speed, at most two garments */
    var carry = Math.max(-2, Math.min(2, -vel * 220 / unit()));
    go(Math.round(pos + carry), true);
    setTimeout(function () { justDragged = false; }, 80);
  };
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);

  /* a sideways trackpad swipe turns it too; vertical scrolling is left alone */
  var wheelT = 0;
  stage.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 1) return;
    e.preventDefault();
    cancelAnimationFrame(tween); moving = true; root.classList.add('is-moving'); clearTimeout(startT);
    pos += e.deltaX / unit(); schedule();
    clearTimeout(wheelT);
    wheelT = setTimeout(function () { go(Math.round(pos), true); }, 140);
  }, { passive: false });

  /* colour buttons: swap the 360 of that garment and its link */
  caps.forEach(function (cap, k) {
    var it = items[k], link = cap.querySelector('[data-rosa-link]');
    var wraps = $$('.rosa__spin', it), btns = $$('[data-rosa-color]', cap);
    var choose = function (idx, focus) {
      wraps.forEach(function (w) {
        var on = w.getAttribute('data-rosa-spin') === String(idx), sEl = w.querySelector('[data-spin]');
        if (!on && !w.hidden && sEl && sEl.__spin) sEl.__spin.stop();
        w.hidden = !on;
        /* hidden colours carry their poster as data-poster, so the page does not fetch them up front */
        var pv = on && w.querySelector('video[data-poster]'); if (pv) { pv.poster = pv.getAttribute('data-poster'); pv.removeAttribute('data-poster'); }
        if (on && link && w.getAttribute('data-url')) link.href = w.getAttribute('data-url');
      });
      btns.forEach(function (b) { var on = b.getAttribute('data-rosa-color') === String(idx); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
      if (k === cur) { var s = spinOf(it); if (s) s.start(); }
      schedule();
    };
    btns.forEach(function (b, j) {
      b.addEventListener('click', function () { choose(b.getAttribute('data-rosa-color'), false); });
      b.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return; e.preventDefault();
        var nb = btns[(j + d + btns.length) % btns.length]; choose(nb.getAttribute('data-rosa-color'), true);
      });
    });
  });

  /* the phones' light mp4 (data-src-sd) is derived from the 1080p file name in v3-spin: if that file ever
     fails to load, the garment falls back to the stream (or the full-size file) instead of a still poster */
  $$('[data-spin-video]', root).forEach(function (v) {
    v.addEventListener('error', function () {
      var el = v.closest('[data-spin]'), sp = el && el.__spin, sd = el && el.getAttribute('data-src-sd');
      if (!sp || v.__sdFailed || !sd || v.getAttribute('src') !== sd) return;
      v.__sdFailed = true;
      var hls = el.getAttribute('data-src-hls'), hd = el.getAttribute('data-src-hd');
      sp.src = (hls && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl') ? hls : '') || hd;
      if (!sp.src || sp.src === sd) return;
      v.src = sp.src; sp.resume(false);
    });
  });

  /* ---------- start ---------- */
  var lastW = 0, lastH = 0;
  var onResize = function () {
    var r = stage.getBoundingClientRect();
    if (Math.abs(r.width - lastW) < 1 && Math.abs(r.height - lastH) < 1) return;
    lastW = r.width; lastH = r.height;
    if (measure()) render(); /* same frame: no half-resized picture */
  };
  if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(stage); else window.addEventListener('resize', onResize);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) schedule(); }, { rootMargin: '200px 0px' }).observe(root);
  } else { onScreen = true; }
  if (measure()) render();
  window.addEventListener('npv:store', function () { if (measure()) render(); startFront(); });
})();
